import { render, staticRenderFns } from "./CreateCustom.vue?vue&type=template&id=19ca6ed6&"
import script from "./CreateCustom.vue?vue&type=script&lang=js&"
export * from "./CreateCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports